import { RootState } from '../../store';

export const getActiveStep = (state: RootState) => state.stepperDetails.activeStep;

export const getBackAction = (state: RootState) => state.stepperDetails.backAction;

export const getStepperTitles = (state: RootState) => state.stepperDetails.titles;

export const getStepperTitlesV2 = (state: RootState) => state.stepperDetails.titlesV2;
